import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'
import OverviewReducer from './Reducers/Overview'
import MonthlyActiveUserReducer from './Reducers/MonthlyActiveUsers'
import FilterReducer from './Reducers/Filters'
import AccountReducer from './Reducers/Account'
import ContentReducer from './Reducers/Content'
import SearchReducer from './Reducers/Search'
import OtherReducer from './Reducers/Other'
import NotificationReducer from './Reducers/Notifications'
import DetailsReducer from './Reducers/Details'
import DateFilter from './Reducers/DateFilter'
import { usersEpic, contentEpic, topFoldersEpic } from './Epics/Content'
import { groupsEpic, profilesEpic } from './Epics/FilterList'
import { overviewEpic } from './Epics/Overview'
import { monthlyActiveUsersEpic } from './Epics/MonthlyActiveUsers'
import { searchTermEpic, topBannerEpic } from './Epics/Other'
import { pushNotificationEpic, pushEventNotificationEpic, pushAlertNotificationEpic, pushSmsNotificationEpic } from './Epics/Notifications'
import { accessTokenEpic, fetchFailEpic } from './Epics/Account'
import {
  userDetailsEpic,
  contentDetailsEpic,
  adminDetailsEpic,
  notificationsDetailsEpic,
  notificationUsersEpic,
  alertDetailsEpic
} from './Epics/Details'
import GenerateReportReducer from './Reducers/GenerateReport'
import {
  generateContentReportEpic,
  generateSMSUsersReportEpic,
  generateUserReportEpic
} from './Epics/GenerateReport'
import { searchEpic } from './Epics/Search'
import { globalConfigEpic } from './Epics/Global'
import GlobalConfigReducer from './Reducers/Global'
import {
  smsDetailsEpic,
  smsMembersSubscribedEpic,
  smsMembersUnsubscribedEpic,
  smsUserEpic,
  smsHistoryEpic
} from './Epics/Sms'
import SmsReducer from './Reducers/Sms'
import ImpressionStatsReducer from './Reducers/ImpressionStats'
import { impressionStatsEpic } from './Epics/ImpressionStats'
import ContentImpressionReducer from './Reducers/ContentImpression'
import { contentImpressionStatsEpic } from './Epics/ContentImpression'

/**
 * external call to combineReducers
 * @param {Object<Reducer>} reducerList A list of reducers as properties
 */
const appriseApp = combineReducers({
  overview: OverviewReducer,
  monthlyActiveUsers: MonthlyActiveUserReducer,
  filterSources: FilterReducer,
  account: AccountReducer,
  content: ContentReducer,
  search: SearchReducer,
  other: OtherReducer,
  notification: NotificationReducer,
  details: DetailsReducer,
  generateReport: GenerateReportReducer,
  dateFilter: DateFilter,
  globalConfig: GlobalConfigReducer,
  sms: SmsReducer,
  contentImpression: ContentImpressionReducer,
  impressionStats: ImpressionStatsReducer
})
/**
 * external call to combineEpics
 * @param {List<Epics>} epicsList
 */
export const appriseEpics = combineEpics(
  topFoldersEpic,
  usersEpic,
  groupsEpic,
  contentEpic,
  profilesEpic,
  overviewEpic,
  monthlyActiveUsersEpic,
  pushNotificationEpic,
  pushEventNotificationEpic,
  pushAlertNotificationEpic,
  pushSmsNotificationEpic,
  searchTermEpic,
  topBannerEpic,
  accessTokenEpic,
  fetchFailEpic,
  contentDetailsEpic,
  alertDetailsEpic,
  userDetailsEpic,
  adminDetailsEpic,
  notificationsDetailsEpic,
  notificationUsersEpic,
  smsDetailsEpic,
  smsMembersSubscribedEpic,
  smsMembersUnsubscribedEpic,
  generateContentReportEpic,
  generateUserReportEpic,
  searchEpic,
  globalConfigEpic,
  smsUserEpic,
  smsHistoryEpic,
  generateSMSUsersReportEpic,
  impressionStatsEpic,
  contentImpressionStatsEpic
)
export default appriseApp
